export default __webpack_public_path__ + "static/media/premium_card_1@3x.3c91b81b.png";